/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function() {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
    this.clearColors();
    this.setBgColors();
  }

  static setBgColors() {
    if(Shopify.locale == 'es') {
      var blackwhite = document.querySelectorAll('.facet-checkbox[data-tooltip*="Blanco & Negro"]');
    }else if(Shopify.locale == 'en') {
      var blackwhite = document.querySelectorAll('.facet-checkbox[data-tooltip*="Black & White"]');
    }else {
      var blackwhite = document.querySelectorAll('.facet-checkbox[data-tooltip*="Blanc & Negre"]');
    }
  }
  // Pendiente de revision posible fallo de plantilla
  static clearColors() {
    /*
    // Mapeo de idioma -> nombre del filtro de color a mostrar
    const colorFilterByLocale = {
      'es': 'Color',
      'ca': 'Color',
      'en': 'Color',
      'fr': 'Color',
      'it': 'Color',
      'de': 'Color'
    };

    // Obtener idioma base (en-US -> en, fr-FR -> fr)
    const locale = Shopify.locale ? Shopify.locale.split('-')[0] : 'es';
    const filterToShow = colorFilterByLocale[locale] || 'Color';

    // Buscar todos los filtros de color por data-filter
    const colorFilters = document.querySelectorAll('collapsible-row[data-filter="Color"], collapsible-row[data-filter="Colour"], collapsible-row[data-filter="Couleur"], collapsible-row[data-filter="Colore"], collapsible-row[data-filter="Farbe"]');

    colorFilters.forEach(filter => {
      const filterName = filter.getAttribute('data-filter');
      if (filterName === filterToShow) {
        filter.style.display = '';
      } else {
        filter.style.display = 'none';
      }
    });*/
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        FacetFiltersForm.clearColors();                                                                                                                                   
        FacetFiltersForm.setBgColors();

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    FacetFiltersForm.clearColors();                                                                                                                                   
    FacetFiltersForm.setBgColors();
    
    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      if(document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`) != null){
        document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.replaceState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
    {
      section: document.getElementById('product-grid').dataset.id,
    }];
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Hay DOS selects de ordenación: #SortBy (barra) y #SortByMobile (drawer),
    // cada uno en su formulario. renderPage no los resincroniza, así que si se
    // ordena en uno y luego se toca un filtro del otro, el valor viejo del
    // segundo pisaba la ordenación. Al cambiar uno, igualamos el otro.
    if (event.target && event.target.name === 'sort_by') {
      document.querySelectorAll('[name="sort_by"]').forEach((sel) => {
        if (sel !== event.target) sel.value = event.target.value;
      });
    }

    const form = event.target.closest('form');
    const formElements = Array.from(form.elements);
    const mergedParams = new URLSearchParams();
  
    // Solo añadimos campos activos y con valor
    formElements.forEach((element) => {
      if (!element.name || element.disabled) return;
  
      const type = element.type;
  
      // Si es checkbox o radio, solo añadimos si está marcado
      if ((type === 'checkbox' || type === 'radio') && !element.checked) return;
  
      // Si es input vacío, lo ignoramos
      if ((type === 'text' || type === 'search' || type === 'number') && !element.value) return;
  
      mergedParams.append(element.name, element.value);
    });

    // Los controles de facetas están repartidos en VARIOS formularios: la
    // ordenación vive en #FacetFiltersForm-bar y los filtros en el formulario
    // de filtros (#FacetFiltersForm / #FacetFiltersFormMobile). Como aquí solo
    // se leía el formulario que dispara el evento, al ordenar se perdían los
    // filtros (y al filtrar, la ordenación).
    //
    // Completamos con los demás formularios, pero SOLO con nombres que el
    // formulario enviado no controla: así el enviado sigue mandando sobre lo
    // suyo y desmarcar una casilla la sigue quitando.
    const ownNames = new Set(formElements.map((el) => el.name).filter(Boolean));
    const alreadyAdded = new Set();

    document.querySelectorAll('facet-filters-form form').forEach((otherForm) => {
      if (otherForm === form) return;

      Array.from(otherForm.elements).forEach((element) => {
        if (!element.name || element.disabled) return;
        if (ownNames.has(element.name)) return;

        const type = element.type;
        if ((type === 'checkbox' || type === 'radio') && !element.checked) return;
        if ((type === 'text' || type === 'search' || type === 'number') && !element.value) return;

        const key = element.name + '=' + element.value;
        if (alreadyAdded.has(key)) return;
        alreadyAdded.add(key);

        mergedParams.append(element.name, element.value);
      });
    });
  
    // Limpiar precios por defecto
    if (mergedParams.get('filter.v.price.gte') === "0.00") {
      mergedParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      const max = parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2);
      if (mergedParams.get('filter.v.price.lte') === max) {
        mergedParams.delete('filter.v.price.lte');
      }
    }
  
    // Validar disponibilidad
    FacetFiltersForm.validateAvailabilityFilter(mergedParams);
  
    // Renderizar resultados con los nuevos filtros
    FacetFiltersForm.renderPage(mergedParams.toString(), event);
  }
  
  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  static validateAvailabilityFilter(searchParams) {
    const disponibilidadCheckbox = document.querySelector('.facets__mobile_form collapsible-row[data-filter=Disponibilidad] .custom-checkbox');
    if (disponibilidadCheckbox && !disponibilidadCheckbox.checked) {
      disponibilidadCheckbox.checked = true;
      searchParams.set('filter.v.availability', '1');
    }
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function(values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function(values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new PriceSlider();
  new FacetsToggle();
});

/**
 * Ordenar valores del filtro de descuento
 * Orden: "Hasta el 30%" primero, luego ascendente por porcentaje
 */
function sortDiscountFilter() {
  // Definir el orden deseado de los valores de descuento
  const discountOrder = [
    'Hasta el 30%',
    'Del 30% al 49%',
    'Del 50% al 69%',
    'Del 70% o más'
  ];

  // Buscar el filtro de descuento (ajusta el selector si es necesario)
  const discountFilters = document.querySelectorAll('collapsible-row[data-filter*="escuento"], collapsible-row[data-filter*="iscount"]');

  discountFilters.forEach(filterContainer => {
    const list = filterContainer.querySelector('ul');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('li'));
    if (items.length === 0) return;

    // Ordenar los items según el orden definido
    items.sort((a, b) => {
      const aText = a.textContent.trim();
      const bText = b.textContent.trim();

      // Buscar coincidencia en el orden definido
      let aIndex = discountOrder.findIndex(order => aText.includes(order));
      let bIndex = discountOrder.findIndex(order => bText.includes(order));

      // Si no está en la lista, ponerlo al final
      if (aIndex === -1) aIndex = 999;
      if (bIndex === -1) bIndex = 999;

      return aIndex - bIndex;
    });

    // Reordenar en el DOM
    items.forEach(item => list.appendChild(item));
  });
}

// Ejecutar al cargar la página
document.addEventListener('DOMContentLoaded', sortDiscountFilter);

// Ejecutar después de que los filtros se actualicen (AJAX)
const originalRenderFilters = FacetFiltersForm.renderFilters;
FacetFiltersForm.renderFilters = function(html, event) {
  originalRenderFilters.call(this, html, event);
  // Pequeño delay para asegurar que el DOM se ha actualizado
  setTimeout(sortDiscountFilter, 100);
};